module.exports = __webpack_public_path__ + "images/shimo/document-list-a5da4b931db0b1c21912cf164d9fe305.png";